/* lua.js generated code 0.3.0 */

require("clover/config/ResourceConfig")
require("clover/data/MaintenanceManager")
require("clover/data/ReplayManager")
// require("clover/net/SyncManager")
require("clover/scene/BaseScene")
require("clover/net/OnlineSetterHttp")
require("clover/net/OnlineGetterHttp")
require("clover/net/OfflineHttp")
require("clover/logic/CloverLogic")
require("clover/baseUI/commands/funscare/FunscareConfig")
require("clover/baseUI/commands/funscare/OpenFunscareLogic")
require("clover/scene/component/LoginingAnim")
// require("clover/panel/component/common/UITextButton")
// require("clover/panel/component/common/UIGroupButton")
require("clover/utils/FrameLoader")
require("clover/data/MetaManager")
require("clover/config/home/HomeConfigManager")
require("clover/utils/Api")
require("clover/utils/Toast")
require("clover/dc/init")
require("clover/utils/GameProxy")
require("clover/utils/TextsManager")
require("clover/utils/IpRegionLimitManager")
require("activity/Promotion/PromotionManager")
// 掉落优化标签
require("clover/logic/userTagData/UserTagData")
require("clover/orthogonalGroup/OrthGroupHelper")
require("clover/orthogonalGroup/OrthStrategyHelper")
require("clover/utils/DYAdUtil")
require("clover/utils/PrivacyUtil")
require("clover/panel/account/AccountManager")


const BG_PATH = ['bg/logo.jpg', 'bg/tips_age.png', 'bg/hint.png']
var SnsProxy = require("clover/sns/SnsProxy")
var PreloadSceneWanba = xClass("PreloadSceneWanba", BaseScene)
// var initCounterNum = 2
// var _loadProgress = 1; // 5号打点进度， 2-25% 3-50%， 4-75%
// let _userLogined = false;    // 用户是否登陆

PreloadSceneWanba.create = function (callback) {
    // if (__DEBUG && cc.sys.platform !== cc.sys.WECHAT_GAME) {
    //     let preloader = document.getElementById('preloader')
    //     preloader && preloader.remove()
    //     let splash = document.getElementById('splash')
    //     splash && splash.remove()
    // }
    var s = PreloadSceneWanba.new()
    s.name = "PreloadSceneWanba"
    s.callback = callback
    s.initScene()
    return s
}
PreloadSceneWanba.tipsText = ["首次加载会有点慢哦~", "拼命加载中..."]
// PreloadSceneWanba.prototype.dispose = function () {
//     var self = this
//     //cc.Director:getInstance():getTextureCache():removeUnusedTextures()
//     BaseScene.prototype.dispose.call(self)
// }
PreloadSceneWanba.prototype.onInit = function () {
    var self = this
    // Toast.make("wanba fake oninit")
    
    self.isPreloadComplete = false
    self.isPrivacyOpen = false
    self.isReadyToEnter = true

    // 背景在代码包内，不含高低清，需要加载完背景再进行初始化
    let userDefault = cc.UserDefault.getInstance()
    let orgUseSmallRes = userDefault.getBoolForKey('game.enable.low.effect')
    // __use_small_res = false;
    global.toggleUseLowEffect(false)
    
    function onBgInit() {
        let text2 = "批准文号：新广出审[2017]5279号\n出版物号：ISBN 978-7-7979-8540-6\n著作权人：乐元素科技（北京）股份有限公司\n出版单位：三辰影库音像出版社\n文网游备字：[2016] M-CSG 8059 号"
        let label2 = cc.Label.create(text2, "Arial", 22)
        label2.setPosition(display.width / 2, 80)
        label2.setAlignment(cc.TEXT_ALIGNMENT_CENTER)
        self.addChild(label2)

        self.initPrivacy();

        global.toggleUseLowEffect(orgUseSmallRes)
        // if (window.mini && mini.supportPlatformLoading())
        //     mini.loadingComplete({});

        // __use_small_res = orgUseSmallRes;

        // dc4UserLoad(21);
        // self.dispatchEvent({name: "PreloadSceneWanbaBgInitEvt"})
    }
    
    self.mainNode = cc.Layer.create()
    self.mainNode.setPosition(display.center)
    self.addChild(self.mainNode)

    function nothing() {}
            
    ResManager.load(BG_PATH, {
        onSuccess: ()=> {
            // Toast.make("resource load finish")
            let bg = cc.Sprite.create(BG_PATH[0])
            self.addChild(bg, -1)
            let scale = display.height / bg.getContentSize().height
            bg.setScale(scale)
            bg.setPosition(display.center)
            //
            let tips_age = cc.Sprite.createWithSpriteFrameName(BG_PATH[1])
            tips_age.setScale(0.8 * 110 / tips_age.getContentSize().width)
            tips_age.setPosition(display.width - tips_age.getContentSize().width * 0.5, display.height - tips_age.getContentSize().height * 0.5)
            self.addChild(tips_age)

            let hint = cc.Sprite.createWithSpriteFrameName(BG_PATH[2])
            hint.setScale(0.6 * 750 / hint.getContentSize().width )
            hint.setPosition(display.width / 2, 180)
            self.addChild(hint)

            onBgInit();
        },
        onFailure: onBgInit,
        autoRetry: 0
    }).then(nothing)
    .catch(nothing)

    self.progressDCAble = false;
}

//重新设置场景的坐标位置
PreloadSceneWanba.prototype.onViewChanged = function () {
    let self = this

}

PreloadSceneWanba.prototype.initPreloadSceneWanba = function () {
    var self = this
    // self.initPrivacy();
    // self.initProgress()
    // self.initTip()
    // self.prepareGame();

    // if (window.mini) {        
    //     self.updateProgressBar(0.01);
    //     self.checkCacheUpdate();
    //     self.updateProgressBar(0.02);
    //     self.prepareGame();
    // } else {
    //     self.updateProgressBar(0.02);
    //     self.prepareGame();
    // }
}

PreloadSceneWanba.prototype.initPrivacy = function () {
    //oppo平台开启
    // Toast.make("wanba initprivacy")
    var self = this
    // if (!PrivacyUtil.isOpen()){
    //     return
    // }
    //加载隐私资源
    PrivacyUtil.loadRes(()=>{

        var privacy_config =  PrivacyUtil.getPrivacy_config()
        if (!privacy_config){
            return
        }

        //不同意或未选择过隐私政策的强弹
        if (!PrivacyUtil.getPrivacyStorage()){
            self.isPrivacyOpen = true
            PrivacyUtil.openMiniPrivacyPanel(function(){
                //agreecb
                self.isPrivacyOpen = false
                PrivacyUtil.savePrivacyStorage(1)
                if (self.isReadyToEnter){
                    self.gotoNextScene()
                }
                
            },function (){
                //disagreecb
                self.isPrivacyOpen = false
                PrivacyUtil.savePrivacyStorage(0)
                SnsProxy.getInstance().popBack()
            })
               
        }else {
            self.gotoNextScene()
        }

        console.log("PrivacyUtil.getPrivacyStorage()", PrivacyUtil.getPrivacyStorage())

        

        //加载界面下方的两个按钮
        let offset = 90
        let height = 180

        // 用户协议
        let lable_user = cc.Label.createWithSystemFont(privacy_config["privacy.user_agreement.id"], null, 25)
        lable_user.setTextColor(cc.c4b(154, 252, 255, 255))
        lable_user.setPosition(display.width / 2 - offset, height)
        lable_user.setAnchorPoint(0.5, 0.5)
        lable_user.setContentSize(cc.size(150, 42))
        UIButton.create(lable_user, true).on(UIButtonEvent.Click, function () {
            if (self.isPrivacyOpen){
                return
            }
            self.isPrivacyOpen = true
            PrivacyUtil.openPrivacyPanel("userAgreement", function (){
                self.isPrivacyOpen = false
                if (self.isReadyToEnter){
                    self.gotoNextScene()
                }
            },true)
        })
        self.addChild(lable_user)
        
        //和
        let lable_and = cc.Label.createWithSystemFont("和", null, 25, cc.c4b(255, 255, 255, 255))
        lable_and.setPosition(display.width / 2 , height)
        self.addChild(lable_and)

        // 隐私政策
        let lable_priv = cc.Label.createWithSystemFont(privacy_config["privacy.privacy_policy.id"], null, 25)
        lable_priv.setTextColor(cc.c4b(154, 252, 255, 255))
        lable_priv.setAnchorPoint(0.5, 0.5)
        lable_priv.setContentSize(cc.size(140, 42))
        lable_priv.setPosition(display.width / 2 + offset, height)
        self.addChild(lable_priv)
        UIButton.create(lable_priv, true).on(UIButtonEvent.Click, function () {
            if (self.isPrivacyOpen){
                return
            }
            self.isPrivacyOpen = true
            PrivacyUtil.openPrivacyPanel("privacyPolicy", function (){
                self.isPrivacyOpen = false
                if (self.isReadyToEnter){
                    self.gotoNextScene()
                }
            },true)
        })
    

    
        
    });
    

}

/**
 * 判断是否需要清理一波缓存
 */
PreloadSceneWanba.prototype.gotoNextScene = function() {
    let self = this
    // Toast.make("fake gotonextscene")
    self.callback && self.callback()
    // PreloadScene.prototype.gotoNextScene 
}


module.exports = PreloadSceneWanba
